// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { getCostType, getFeeByDimension } from '../../../utils/cells';
import { MenuItem } from '@mui/material';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import i18n from '../../../i18n';
import { calculationTypes, costType } from '../statuses';
import UpdateCommissionDialog from '../../dialogs/UpdateCommissionDialog';
import { GridDataAdapter } from '../../../adapter/DataAdapter';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
const commissionsHead = [
    {
        id: 'name',
        label: 'name',
        alignRight: false,
        cell: 'Text',
        onlyRead: true,
        default: ''
    },
    {
        id: 'dimension',
        label: 'dimension',
        alignRight: false,
        cell: 'Items',
        items: ['percent', 'fixed'],
        displayGrid: true,
        customSort: 'fee',
        variant: 'reversed', // 'default' or 'reversed'
        extraRender: (value, row) => getFeeByDimension(value, row)
    },
    {
        id: 'fee',
        label: 'fee',
        alignRight: false,
        cell: 'Number',
        displayGrid: false,
        showIfDialog: (data) => data.dimension === 'percent'
    },
    {
        id: 'fee',
        label: 'fee',
        alignRight: false,
        cell: 'Amount',
        displayGrid: false,
        showIfDialog: (data) => data.dimension === 'fixed'
    },

    {
        id: 'minimalCommission',
        label: 'minimalCommission',
        alignRight: false,
        cell: 'Amount',
        displayGrid: true
    },
    {
        id: 'dateFrom',
        label: 'dateFrom',
        alignRight: false,
        cell: 'DateTime',
        default: '',
        clearable: true
    },
    {
        id: 'dateTo',
        label: 'dateTo',
        alignRight: false,
        cell: 'DateTime',
        default: '',
        clearable: true
    }
];
export default class CommissionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicCommissions';
        this.Server = this.props.context.getState().server.publicCommissions;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'name',
            'comment',
            'terminal.name',
            'gateway.name'
        ];
        this.commissionsHead = commissionsHead;
        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'comment',
                label: 'comment',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'costType',
                label: 'costType',
                alignRight: false,
                cell: 'Items',
                items: Object.keys(costType),
                extraRender: (value, row) => getCostType(value, row),
                displayGrid: true
            },
            {
                id: 'agentId',
                label: 'agent',
                alignRight: false,
                cell: 'Select',
                object: 'agent',
                from: 'publicAgents',
                show: 'name',
                displayGrid: false,
                showIfDialog: (data) => data.costType === 'agent'
            },
            {
                id: 'terminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'terminal',
                from: 'publicMerchantTerminals',
                filterCell: 'Context',
                filterBy: 'publicMerchantTerminals',
                displayGrid: false,
                showIfDialog: (data) =>
                    data.costType === 'merchant' ||
                          data.costType === 'agent'
            },
            {
                id: 'gatewayId',
                label: 'terminalGateway',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'gateway',
                from: 'publicGateways',
                filterCell: 'Context',
                filterBy: 'publicGateways',
                displayGrid: false,
                showIfDialog: (data) =>
                    data.costType === 'gateway' ||
                          data.costType === 'agent'
            },
            {
                id: 'calculationType',
                label: 'calculationType',
                alignRight: false,
                cell: 'Items',
                items: Object.keys(calculationTypes),
                displayGrid: true
            },
            {
                id: 'dimension',
                label: 'dimension',
                labelCell: 'fee',
                alignRight: false,
                cell: 'Items',
                items: ['percent', 'fixed'],
                displayGrid: true,
                customSort: 'fee',
                variant: 'replaced', // 'default' or 'reversed'
                extraRender: (value, row) => getFeeByDimension(value, row)
            },
            {
                id: 'fee',
                label: 'fee',
                alignRight: false,
                cell: 'Number',
                displayGrid: false,
                showIfDialog: (data) => data.dimension === 'percent'
            },
            {
                id: 'fee',
                label: 'fee',
                alignRight: false,
                cell: 'Amount',
                displayGrid: false,
                showIfDialog: (data) => data.dimension === 'fixed'
            },

            {
                id: 'minimalCommission',
                label: 'minimalCommission',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'dateFrom',
                label: 'dateFrom',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true,
                // default: 'today', // 'today' or date string '2023-01-01T00:00:00'
                default: '2025-01-01T00:00:00'
            },
            {
                id: 'dateTo',
                label: 'dateTo',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true,
                default: '2050-01-01T00:00:00'
            },
            // {
            //     id: 'isNetCost', //is_net_cost -> change into enum: merchant gateway agent
            //     label: 'isNetCost',
            //     alignRight: false,
            //     cell: 'Checkbox',
            //     type: 'boolean',
            //     displayGrid: true
            // },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            commissionId: null,
            commissionDateDialogOpen: false,
            commissionsData: {}
        };
    }

    getDialogData = (id) => {
        const data = this.List.find((item) => item.id === id);
        return GridDataAdapter.transform(data, this.Head);
    };

    handleUpdateCommissionDate = () => {
        const commissionId = this.state.menuClickItemId;

        const commissionsData = this.getDialogData(commissionId);

        this.setState({
            commissionDateDialogOpen: true,
            commissionId,
            commissionsData
        });
        this.handleCloseMenu();
    };
    handleCloseCommissionDateDialog = () => {
        this.setState({
            commissionDateDialogOpen: false,
            commissionId: null
        });
    };
    handleSaveCommissionDate = () => {
        this.setState({
            commissionDateDialogOpen: false,
            commissionId: null
        });
        this.retrieveData();
    };
    // isDateInPast = (dateStr) => {
    //     console.log('dateStr', dateStr);
    //     if (!dateStr) return false; // If no date is provided, consider it as past
    //     const today = new Date();
    //     today.setHours(0, 0, 0, 0);
    //     const date = new Date(dateStr);
    //     date.setHours(0, 0, 0, 0);
    //     return date < today;
    // };
    renderCustomMenuItems() {
        // const currentCommission = this.List.find(
        //     (item) => item.id === this.state.menuClickItemId
        // );
        // const isCommissionEndDateInPast = currentCommission?.id
        //     ? this.isDateInPast(currentCommission?.dateTo)
        //     : false;

        const isCommissionDateChangeAllowed = this.allowedPermission('update');
        // !isCommissionEndDateInPast;
        return isCommissionDateChangeAllowed ? (
            <MenuItem
                key="changeCommissionDate"
                onClick={() => this.handleUpdateCommissionDate()}
            >
                <EditCalendarIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.changeCommissionDate')}
            </MenuItem>
        ) : null;
    }
    renderCustom() {
        // render custom change commission date dialog
        const { commissionDateDialogOpen, commissionId, commissionsData } =
            this.state;
        return (
            <UpdateCommissionDialog
                name={this.Name}
                dialogOpen={commissionDateDialogOpen}
                onClose={this.handleCloseCommissionDateDialog}
                onSave={this.handleSaveCommissionDate}
                Head={this.commissionsHead}
                dialogData={commissionsData}
                server={this.Server}
                id={commissionId}
                role={this.state.currentUserRole}
            />
        );
    }
}
